import React from 'react'
import { Table } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { Toaster } from '@CommonComponents/toast'
import NextButton from './NextButton'
import PreviousButton from './PreviousButton'
import ExportModal from './ExportModal'

export const TransferTable = props => {
  let transfers = props.transfers
  let updateTransfers = props.updateTransfers
  let startingAfter = props.startingAfter
  let updateStartingAfter = props.updateStartingAfter
  let endingBefore = props.endingBefore
  let updateEndingBefore = props.endingBefore
  let hasMoreTransfers = props.hasMoreTransfers
  let updateHasMoreTransfers = props.updateHasMoreTransfers

  return (
    <React.Fragment>
      <Toaster />
      {transfers.length > 0 && <ExportModal accountID={props.accountID} />}
      {transfers.length > 0 ? (
        <React.Fragment>
          <Table striped hover>
            <thead>
              <tr>
                <th>Date</th>
                <th>Source</th>
                <th className="text-right">Amount</th>
              </tr>
              {transfers.map((transfer, i) => (
                <tr key={i}>
                  <td>{transfer.created}</td>
                  <td>{transfer.description}</td>
                  <td className="text-right">
                    ${(transfer.amount / 100).toFixed(2)}
                  </td>
                </tr>
              ))}
            </thead>
          </Table>
          <div className="pull-right">
            {endingBefore && (
              <PreviousButton
                updateTransfers={updateTransfers}
                endingBefore={endingBefore}
                updateEndingBefore={updateEndingBefore}
                updateStartingAfter={updateStartingAfter}
                updateHasMoreTransfers={updateHasMoreTransfers}
                accountID={props.accountID}
              />
            )}
            {hasMoreTransfers && (
              <NextButton
                updateTransfers={updateTransfers}
                startingAfter={startingAfter}
                updateStartingAfter={updateStartingAfter}
                updateHasMoreTransfers={updateHasMoreTransfers}
                updateEndingBefore={updateEndingBefore}
                accountID={props.accountID}
              />
            )}
          </div>
        </React.Fragment>
      ) : (
        <div className="text-muted text-center">
          Student purchases will appear here.
        </div>
      )}
    </React.Fragment>
  )
}

TransferTable.propTypes = {
  transfers: PropTypes.array.isRequired,
  startingAfter: PropTypes.string,
  endingBefore: PropTypes.string,
  updateEndingBefore: PropTypes.func.isRequired,
  hasMoreTransfers: PropTypes.bool.isRequired,
  accountID: PropTypes.string.isRequired,
  updateTransfers: PropTypes.func,
  updateStartingAfter: PropTypes.func,
  updateHasMoreTransfers: PropTypes.func,
}
